<template>
  <div>
    <!-- <label class="mt-2">Lote:</label> -->
    <!-- <div class="d-flex  align-items-center py-3">
      <v-select
        v-model="actualPrinter"
        :options="printers"
        class="margin-multi sp-border-input bg-white w-25 mr-3"
        placeholder="Impresora"
      />
      <CButton color="primary" @click="printItems()" square>Imprimir</CButton>
    </div>-->
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex sp-flex justify-content-between catalogo-text"
          >
            Catálogo de Proveedores
            <router-link class="mt-2 mt-sm-0" :to="{ name: 'NuevoProveedor' }">
              <CButton color="primary" class="mr-1">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Proveedor
              </CButton>
            </router-link>
            <!-- <div class="sp-margin-b">
              <CButton
                @click="selectAll()"
                color="primary"
                class="mr-1 sp-width-butom  d-flex "
              >
                <CIcon class="mr-1" name="cil-check" />Seleccionar Todos
              </CButton>
            </div>
            <div class="sp-margin-b">
              <CButton
                @click="printModal = true"
                color="primary"
                class="mr-1 sp-width-butom  d-flex "
              >
                <CIcon class="mr-1" name="cil-barcode" />Imprimir Codigos
              </CButton>
            </div>-->
          </CCardHeader>
          <CCardBody>
            <!-- <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoading"
            >
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>-->
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #over-table>
                <CRow>
                  <CCol sm="11" col="10">
                    <CInput
                      v-model="filter"
                      @input="searchTimeOut()"
                      placeholder="Búsqueda por proveedores..."
                    />
                  </CCol>
                  <CCol class="p-0" sm="1" col="2">
                    <CDropdown
                      placement="bottom-start"
                      add-menu-classes="pt-0"
                      color="primary"
                      :show.sync="dropdownCustom"
                    >
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-print" />
                        </CButton>
                      </template>

                      <CDropdownItem @click="onClickPrintCodes" class="no-padding">
                        <div class="custom-padding">
                          <CIcon class="mr-1" name="cil-print" />Imprimir
                          Codigos
                        </div>
                      </CDropdownItem>
                    </CDropdown>
                  </CCol>
                </CRow>
              </template>
              <template #check-header>
                <div class="text-center" @click="selectAll()">
                  <CIcon v-if="allSelections" name="cil-x-circle" />
                  <CIcon v-else name="cil-check" />
                </div>
              </template>
              <template #id="{item}">
                <td class="py-2">{{ item.id }}</td>
              </template>
              <template #nombre="{item}">
                <td class="py-2">{{ item.payload.nombre }}</td>
              </template>
              <template #edit="{item}">
                <td class="py-2">
                  <router-link :to="{ name: 'EditarProveedor', params: { id: item.id } }">
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton color="danger" square size="sm" @click="toggleCancel(index, item)">Borrar</CButton>
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => changePage(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      color="danger"
    >
      <h5 class="text-center">¿Deseas borrar al proveedor {{ this.itemModal.name }}?</h5>
      <template #header>
        <h5 class="modal-title">Borrar Proveedor</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton @click="deleteAlmacen(itemModal.index, itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="printModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Imprimir proveedores"
      color="info"
    >
      <label>Impresora</label>
      <v-select
        v-model="actualPrinter"
        :options="printers"
        class="margin-multi sp-border-input bg-white mb-2"
        placeholder="Impresora"
      />
      <CInput
        label="Cantidad de impresiones"
        v-model="itemModalPrint.cantidadCopias"
        placeholder="Cantidad de impresiones"
        type="number"
      ></CInput>
      <template #header>
        <h5 class="modal-title">Imprimir Proveedores</h5>
        <CButtonClose @click="printModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="printModal = false" color="danger">Cancelar</CButton>
        <CButton @click="printItems()" color="success">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";


const fields = [
  { key: "id", label: "ID", _style: "width:5%" },
  { key: "nombre", label: "Nombre", _style: "width:20%" },
  {
    key: "edit",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Proveedores",

  components: {
    vSelect
  },

  data() {
    return {
      items: [],
      fields,
      filter: "",
      check: true,
      printer: window.printerAct,
      printModal: false,
      dropdownCustom: false,
      // printers: [],
      
      cancelModal: false,
      itemModal: { id: "", name: "", index: "" },
      itemModalPrint: { cantidadCopias: 1 },
      isLoading: false,
      allSelections: false,
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      timer: null
    };
  },

  computed: {
    printers() {
      // console.log(window.printersDetected);

      return window.printersDetected();
    },
    actualPrinter() {
      return window.printerAct();
      // ? { value: window.printerAct.uid, label: window.printerAct.name }
      // : null;
    },
  },

  watch: {

  },

  created() {
    window.printSetup();
    this.updateAllInfo();
    // this.isLoading = true;
    // const tra = [
    //   this.$store.dispatch("customHTTP", { schema: "ubicaciones" })
    //   this.$store.dispatch("customHTTP", {
    //     schema: "proveedores",
    //     limit: 50,
    //     page: 1,
    //     filter: {
    //       wherein: [
    //         {
    //           field: "payload->ubicacion_id",
    //           value: [this.ubicacionRaiz]
    //         }
    //       ]
    //     },
    //     ["with-storage"]: ["*"]
    //   })
    // ];
    // Promise.all(tra)
    //   .then(([ubicaciones]) => {
    //     this.ubicaciones = ubicaciones.data;
    //     console.log(ubicaciones)
    //   })
    //   .finally(() => (this.isLoading = false));
  },

  methods: {
    onClickPrintCodes() {
      this.printModal = true;
      this.closeDropdown();
    },
    closeDropdown() {
      this.dropdownCustom = false;
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        // console.log("funciona");
        this.updateItemsSearch(this.filter.toUpperCase());
      }, 800);
    },
    updateItemsSearch(text) {
      this.isLoading = true;
      let template = {
        schema: "proveedores",
        limit: 50,
        page: 1,
        ["with-storage"]: ["*"]
      }

      this.filter != "" ? (template = {
        ...template, filter: {
          ...template.filter,
          and: {
            where: [
              {
                field: "payload->nombre",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              },
            ],
            orWhere:[
              {
                field: "payload->nanoid",
                operator: "like",
                value: `%${text}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        }
      }) : null;


      const catalogo = [
        this.$store.dispatch("customHTTP", template)
      ];
      Promise.all(catalogo)

        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    changePage(event) {
      this.isLoading = true;
      let template = {
        schema: "proveedores",
        limit: 50,
        page: event,
        ["with-storage"]: ["*"]
      }

      this.filter != "" ? (template = {
        ...template, filter: {
          ...template.filter,
          and: {
            where: [
              {
                field: "payload->nombre",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
            ],
            orWhere: [
              {
                field: "payload->nanoid",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        }
      }) : null;

      const catalogo = [
        this.$store.dispatch("customHTTP", template)
      ];
      Promise.all(catalogo)

        .then(([registros]) => {
          this.items = registros.data;
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    updateAllInfo() {
      this.isLoading = true;
      const tra = [
        
        this.$store.dispatch("customHTTP", {
          schema: "proveedores",
          limit: 50,
          page: 1,
          ["with-storage"]: ["*"]
        })
      ];
      Promise.all(tra)
        .then(([ proveedores]) => {
          this.items = proveedores.data
            ? proveedores.data.map(tra => {
                return { ...tra, selected: false };
              })
            : [];
          this.pages = proveedores.paginate.last_page;
          this.page = proveedores.paginate.current_page;
        })
        .finally(() => (this.isLoading = false));
    },

    selectAll() {
      if (this.allSelections) {
        this.items = this.items
          ? this.items.map(tra => {
              return { ...tra, selected: false };
            })
          : [];
        this.allSelections = false;
      } else {
        this.items = this.items
          ? this.items.map(tra => {
              return { ...tra, selected: true };
            })
          : [];
        this.allSelections = true;
      }
    },
    printItems() {
      const idsToPrint = this.items.filter(item => item.selected === true);
      // console.log(idsToPrint);
      idsToPrint.length
        ? idsToPrint.map(proveedor => {
            this.printNanoid(proveedor, this.itemModalPrint.cantidadCopias);
          })
        : null;

      this.printModal = false;
    },
    printNanoid(proveedor, cant) {
      if (proveedor && cant && cant > 0) {
        window.printTicket(
          `^XA^CFA,25^FO25,165^FD${proveedor.payload.nombre}^FS^FO20,20^BY3^BCN,100,Y,N, ^FD${proveedor.payload.nanoid}^PQ${cant}^XZ`
        );
      }
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: index
      };
      this.itemModal = itemIndex;
    },
    deleteAlmacen(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "proveedores",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.sp-border-input {
  border-radius: 4px;
}
.sp-flex {
  flex-direction: row;
}
.sp-margin-b {
  margin-bottom: 0;
}
.sp-width-butom {
  width: 160px;
}
@media (max-width: 768px) {
  .sp-flex {
    flex-direction: column;
  }
  .sp-margin-b {
    margin-bottom: 0.8rem;
  }
}
</style>
